import { useEffect, useState } from "react";
import "../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCalendarDays } from "@fortawesome/free-solid-svg-icons";

export default function AgendaModal({ isOpen, onClose }) {
  const [agenda, setAgenda] = useState(null);
  const secretId = localStorage.getItem("secretId");

  useEffect(() => {
    if (!isOpen || !secretId) return;

    const fetchAgenda = async () => {
      try {
        const res = await fetch(`https://api18081113.sayq.pl/get-agenda/${secretId}`);
        const data = await res.json();

        if (!res.ok) throw new Error(data.error || "Błąd pobierania agendy");

        setAgenda(data.agenda);
      } catch (err) {
        console.error("Błąd ładowania agendy:", err);
        setAgenda("Nie udało się załadować agendy.");
      }
    };

    fetchAgenda();
  }, [isOpen, secretId]);

  if (!isOpen) return null;

  return (
    <>
      <div className="agenda-fix-overlay">
        <div className="agenda-fix-container">
          <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
            <h2 className="m-0 fw-bold d-flex align-items-center gap-3">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                <FontAwesomeIcon icon={faCalendarDays} className="fs-5" />
              </div>
              Agenda
            </h2>
            <button
              onClick={onClose}
              className="btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center transition-transform hover-scale"
              style={{ width: 44, height: 44 }}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>

          <div className="agenda-content-scroll custom-scrollbar">
            {agenda ? (
              <div
                className="agenda-html-content"
                dangerouslySetInnerHTML={{ __html: agenda }}
              ></div>
            ) : (
              <div className="text-center py-5 text-muted opacity-75">
                <FontAwesomeIcon icon={faCalendarDays} size="3x" className="mb-3" />
                <p>Ładowanie agendy...</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        .agenda-fix-overlay {
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background-color: rgba(0,0,0,0.6);
            backdrop-filter: blur(8px);
            z-index: 9999;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px;
            animation: fadeIn 0.3s ease-out;
        }

        .agenda-fix-container {
            background: #fff;
            width: 100%;
            max-width: 1000px;
            height: 90vh; /* Nearly full screen */
            border-radius: 24px;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            padding: 30px;
            display: flex;
            flex-direction: column;
            animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            position: relative;
        }

        @media (max-width: 768px) {
            .agenda-fix-container {
                height: 100vh;
                border-radius: 0;
                padding: 20px;
            }
        }

        .agenda-content-scroll {
            flex: 1;
            overflow-y: auto;
            padding-right: 5px;
        }

        .agenda-html-content {
            font-size: 1.1rem;
            line-height: 1.7;
            color: #374151;
        }
        
        .agenda-html-content p {
            margin-bottom: 1rem;
        }

        /* Custom scrollbar */
        .custom-scrollbar::-webkit-scrollbar { width: 6px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #9ca3af; }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(40px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

        /* Dark Mode Support */
        body.dark-mode .agenda-fix-container {
            background: #1e1e1e;
            color: #f3f4f6;
            border: 1px solid #333;
        }
        body.dark-mode .agenda-html-content {
             color: #e5e7eb;
        }
        body.dark-mode .border-bottom {
            border-color: #333 !important;
        }
        body.dark-mode .btn-light {
             background: #2d2d2d;
             color: #fff;
             border-color: #444;
        }
        body.dark-mode .btn-light:hover {
             background: #3d3d3d;
        }
      `}</style>
    </>
  );
}
